import { render, staticRenderFns } from "./SystemMaintenanceNoticePage.vue?vue&type=template&id=813f7740&scoped=true"
import script from "./SystemMaintenanceNoticePage.vue?vue&type=script&lang=js"
export * from "./SystemMaintenanceNoticePage.vue?vue&type=script&lang=js"
import style0 from "./SystemMaintenanceNoticePage.vue?vue&type=style&index=0&id=813f7740&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "813f7740",
  null
  
)

export default component.exports